/**
 * Object of all logs sent mail
 */
const LOGS_SENT_MAIL = {
  LOGS_ANY: "LOGS_ANY",
  LOGS_MINIMUM: "LOGS_MINIMUM",
  LOGS_DEBUG: "LOGS_DEBUG"
}

export default LOGS_SENT_MAIL
